import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
} from '@ngrx/store';
import {
  IApiCardResponse,
  INewCard,
  INewCardStateCompleted,
  INewCompletedAccountCardsState,
} from 'src/app/api/interfaces/card.interface';
import { IApiAccountResponse } from 'src/app/api/interfaces/configuration.interface';
import { IApiReferralState } from 'src/app/api/interfaces/referral.interface';
import {
  setAccountState,
  setCardState,
  setRefferalState,
  setStateCondition,
  updateBalance,
  updateCompletedCardState,
} from './mainState.actions';

export interface IMainStateActions {
  type:
    | '[State API] Get Config state success'
    | '[WSS Api] update account balance'
    | '[State API] Get Character state success'
    | '[State API] Get Account state success'
    | string;
}
export interface IMainState {
  stateReady: boolean;
  account: IApiAccountResponse;
  cards: INewCardStateCompleted;
  refferal: IApiReferralState;
}
export const initialState: IMainState = {
  stateReady: false,
  account: {
    nickname: '',
    publicId: '',
    socialData: {
      NEAR: {
        socialId: '',
      },
    },
    balances: [
      {
        id: 0,
        currency: 'GOLD',
        quantity: 0.0,
      },
    ],
    tutorial: {
      id: '',
      status: 'IN_PROCESS',
      currentStep: 0,
      lastStep: 0,
    },
    blockhainData: {
      NEAR: {
        blockchainId: '',
        meta: '',
      },
    },
  },
  cards: {
    api: {
      cards: [],
      accountCards: [],
    },
    completedCards: [],
  },
  refferal: {
    referralAccount: {
      referralId: '',
      referralNicknames: [],
      providedReferralId: null,
    },
    referralLink: '',
  },
};

const _mainStateReducer = createReducer(
  initialState,
  on(setAccountState, (state, { responseData }) => {
    return { ...state, account: responseData };
  }),
  on(setCardState, (state, { responseData }) => {
    const completedUserCards = responseData.accountCards.map((userCard) => {
      return {
        cardUI: responseData.cards.find(
          (cardUI) => userCard.cardId === cardUI.id
        ),
        card: userCard,
      };
    });
    return {
      ...state,
      cards: {
        ...state.cards,
        api: responseData,
        completedCards: completedUserCards,
      },
    };
  }),
  on(setRefferalState, (state, { responseData }) => {
    return { ...state, refferal: responseData };
  }),
  on(updateBalance, (state, { WssresponseData }) => {
    if (WssresponseData.currency === 'DIAMOND') {
      const audio = new Audio('assets/sounds/coin.wav');
      audio.volume = JSON.parse(localStorage['audio']).sounds;
      audio.play();
    }
    return {
      ...state,
      account: {
        ...state.account,
        balances: state.account.balances.map((el) =>
          el.id === WssresponseData.id ? WssresponseData : el
        ),
      },
    };
  }),

  on(updateCompletedCardState, (state, { cardUpdate }) => {
    let updatedCardState: INewCompletedAccountCardsState[] = [];
    if (
      state.cards.completedCards.filter(
        (stateCard) =>
          stateCard.card.id ===
          cardUpdate.accountCards.find(
            (updatedCards) => updatedCards.id === stateCard.card.id
          )?.id
      ).length > 0
    ) {
      updatedCardState = state.cards.completedCards.map((stateCard) => {
        const updatedCard = cardUpdate.accountCards.find(
          (updatedCard) => updatedCard.id === stateCard.card.id
        );
        if (cardUpdate) {
          return { ...stateCard, card: { ...stateCard.card, ...updatedCard } };
        } else {
          return stateCard;
        }
      });
    } else {
      const createdCards = cardUpdate.accountCards.map((createdCard) => {
        return {
          cardUI: state.cards.api.cards.find(
            (cardUI) => cardUI.id === createdCard.cardId
          ),
          card: createdCard,
        };
      });
      updatedCardState = state.cards.completedCards.concat(createdCards);
    }
    return {
      ...state,
      cards: { ...state.cards, completedCards: updatedCardState },
    };
  }),
  on(setStateCondition, (state, { ready }) => {
    return { ...state, stateReady: ready };
  })
);

export function MainStateReducer(
  state: IMainState | undefined,
  action: IMainStateActions
) {
  return _mainStateReducer(state, action);
}

export const selectMainState = createSelector(
  createFeatureSelector<IMainState>('mainState'),
  (mainState) => mainState
);
